module.exports = __webpack_public_path__ + "img/18.56855398.png";